import BaseContainer from "@components/ui/BaseContainer";
import { convertToDigited } from "@utils/helpers/numbers";
import useProjectContext from "@utils/hooks/context/useProjectContext";
import useDynamicImage from "@utils/hooks/ui/useDynamicImage";
import clsx from "clsx";
import classes from "./Aim.module.scss";

const Aim = () => {
  const { project } = useProjectContext();

  const { src } = useDynamicImage(`projects/${project.id}/aim.png`);

  return (
    <BaseContainer className={classes.aim}>
      <h3 className={classes.aim__title}>{project.aim.title}</h3>

      <div>
        <h2 className={classes.aim__subtitle}>{project.aim.subtitle}</h2>
        <ul className={clsx(classes.aim__suggsetions, classes.suggestions)}>
          {project.aim.suggestions.map((suggestion) => (
            <li key={suggestion.title} className={classes.suggestions__item}>
              <h3 className={classes.suggestions__title}>{suggestion.title}</h3>
              <p className={classes.suggestions__text}>{suggestion.text}</p>
            </li>
          ))}
        </ul>

        <img className={classes.aim__img} src={src} alt="" />

        <ul className={clsx(classes.aim__road, classes.road)}>
          {project.aim.road.map((step, index) => (
            <li key={step} className={clsx(classes.road__item, classes.item)}>
              <span className={classes.item__digit}>{convertToDigited(index + 1)}</span>
              <h3 className={classes.item__text}>{step}</h3>
            </li>
          ))}
        </ul>
      </div>
    </BaseContainer>
  );
};

export default Aim;
